import {
  FilterId,
  FilterOptionsType,
  SingleSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';

export enum BookingWindow {
  upcoming = 'upcoming',
  past = 'past',
}

export class BookingWindowFilter extends SingleSelectFilter<void> {
  id = FilterId.bookingWindow;
  optionsType = FilterOptionsType.list;
  optionsList = Object.values(BookingWindow);
  clearable = false;
}
